import { render, staticRenderFns } from "./SplitBlock.vue?vue&type=template&id=ba2c2844&scoped=true&"
import script from "./SplitBlock.vue?vue&type=script&lang=js&"
export * from "./SplitBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2c2844",
  null
  
)

export default component.exports